import React, { useState, Fragment } from "react";
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { getSchoolFromPostcode } from "../../../utils/storedProcedures";
import { FloatingLabel } from "react-bootstrap";

const PostCodeSearch = (props) => {

  const [schoolResults, setSchoolResults] = useState([]);
  const [schoolPostcode, setSchoolPostcode] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [error, setError] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState("");


  const updateSchoolDetails = school => {
    const { org, dfes, postcode, AddressComplete } = school;
    const schoolDetails = {
      centreName: org || "",
      dfeNumber: dfes || "",
      postcode: postcode || "",
      centreAddress: AddressComplete || ""
    };
    props.updateSchoolDetails(schoolDetails);
  };

  const searchIsValid = item => {
    const postcode = item;
    if (postcode.length >= 3) {
      setError(false);
      searchForSchool();
    } else {
        setSchoolResults([]);
        setError(true);
        setFeedbackMessage("Your postcode needs to be at least 3 characters");
    }
  };

  const searchForSchool = async () => {
    const schoolResults = await getSchoolFromPostcode([
      schoolPostcode
    ]);
    setSchoolResults(schoolResults);
    if (schoolResults.length === 0) {
        setError(true);
        setFeedbackMessage((
          <span className="no-list">
            Sorry, we couldn't find a match for that postcode. Please try again
            or{" "}
            <span
              className="postcode-search__link"
              onClick={() => {
                setSchoolResults([]);
                props.setFormVisibility(true);
                props.enableAutoFormFields();
                props.setManualEntry(true);
              }}
            >
              click here
            </span>{" "}
            to enter your address manually.
          </span>
        ))
    }
  };

  const clearSchools = () => {
    setSchoolResults([]); 
  };

  const SchoolList = () => (
    <div className="postcode-search__listwrap">
      <ListGroup id="postcode-search__list" variant="flush">
        {schoolResults.map(school => (
          <Fragment>
            <ListGroup.Item
              className="postcode-search__item"
              eventKey={school.dfes}
              onClick={e => {
                props.setFormVisibility(true);
                props.disableAutoFormFields();
                updateSchoolDetails(school);
                clearSchools();
                window.scrollTo(0,0);
                props.setManualEntry(false);
              }}
              style={{ cursor: "pointer" }}
            >
              <p key={school.dfes}>
                <b>DfES: </b> {school.dfes} <br /> <b>Org: </b>
                {school.org}
              </p>
            </ListGroup.Item>
          </Fragment>
        ))}
      </ListGroup>
    </div>
  );

  const handleChange = (e) => {
    e.preventDefault();
    setSchoolPostcode(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchIsValid(schoolPostcode)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
  }

    return (
      <Container fluid>
        <Row className="school-postcode__row">
          <Col sm={5} style={{padding: 0}}>
            <Form onSubmit={handleSubmit}>
              <FloatingLabel controlId="postcode-search" label="School Postcode">
                <Form.Control
                  type="text"
                  placeholder="schoolPostcode"                  
                  value={schoolPostcode}
                  onKeyPress={handleKeyPress}
                  onChange={handleChange}
                  />
              </FloatingLabel>
            </Form>
          </Col>
          <Col sm={7}>
            <Button
              variant="outline-primary"
              id="postcode-search__button"
              onClick={() => searchIsValid(schoolPostcode)}
            >
              <i className="fa fa-school"> </i> Select your school
            </Button>
          </Col>
        </Row>
            <div className="errorFeedback__message">
              {error ? feedbackMessage : null}
            </div>
        <Row>
          <Col md={12}>
            {schoolResults.length > 0 ? SchoolList() : null}
            <button
              id="manual-address-link"
              className="btn btn-primary complete-order-btn"
              style={
                !schoolResults.length > 0 ? { display: "none" } : null
              }
              onClick={() => {
                setSchoolResults([]);
                props.setFormVisibility(true);
                props.enableAutoFormFields();
                props.setManualEntry(true);
                window.scrollTo(0,0);
              }}
              >
              My school is not on this list
            </button>
          </Col>
        </Row>
    </Container>
    );
  }

PostCodeSearch.propTypes = {};

export default PostCodeSearch;
